import environment from "../environment";
import { refreshToken } from "../services/auth.service";
import store from "../store";
import { setSessionEnd } from "../store/slices/errorSlice";

import { loggingout } from "./loggingOut";

export const getRefreshToken = async (refresh_token) => {
  const requestBody = {
    grantType: "RefreshToken",
    refreshToken: refresh_token,
  };
  const response = await refreshToken(requestBody);
  if (response?.status === 200) {
    localStorage.setItem(
      environment.TOKEN_KEY,
      response?.data?.data?.accessToken
    );
    localStorage.setItem(
      environment.REFRESH_TOKEN_KEY,
      response?.data?.data?.refreshToken
    );
    // window.location.reload();
  } else if (response?.status === 401) {
    store.dispatch(setSessionEnd(true));
    loggingout();
  }
};
